<template>
  <Breadcrumb :items="breadcrumbs" />
  <Loading v-if="loading" />

  <div v-if="!loading" class="container-fluid my-3">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h4>باركود الطلاب — {{ gradeName }} ({{ students.length }})</h4>
      <div class="d-flex gap-2">
        <router-link :to="`/grades/${gradeSlug}/students/barcodes-print`" class="btn btn-warning">
          <i class="pi pi-print me-1"></i> طباعة الكل
        </router-link>
        <router-link :to="`/grades/${gradeSlug}/students`" class="btn btn-secondary">
          <i class="pi pi-arrow-right me-1"></i> رجوع
        </router-link>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-bordered table-hover align-middle">
        <thead class="table-dark">
          <tr>
            <th style="width:60px">#</th>
            <th>اسم الطالب</th>
            <th style="width:100px" class="text-center">رقم الطالب</th>
            <th class="text-center">الباركود</th>
            <th style="width:120px" class="text-center">تحميل</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(student, index) in students" :key="student.user_id">
            <td>{{ index + 1 }}</td>
            <td>{{ student.name }}</td>
            <td class="text-center fw-bold">{{ student.user_id }}</td>
            <td class="text-center py-2">
              <BarcodeLabel
                :ref="`bc_${student.user_id}`"
                :studentId="student.user_id"
                :barWidth="2"
                :barHeight="55"
              />
            </td>
            <td class="text-center">
              <button class="btn btn-sm btn-outline-primary" @click="downloadBarcode(student)">
                <i class="pi pi-download me-1"></i> تحميل
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Breadcrumb from '@/components/global/breadcrumb.vue';
import Loading from '@/components/global/loading.vue';
import BarcodeLabel from '@/components/global/BarcodeLabel.vue';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: 'StudentsBarcodes',
  components: { Breadcrumb, Loading, BarcodeLabel },

  data() {
    return {
      students: [],
      loading: false,
    };
  },

  computed: {
    gradeStore() { return useGradeStore(); },

    gradeSlug() { return this.$route.params.gradeSlug; },

    grade() {
      const slug = this.gradeSlug;
      return this.gradeStore.activeGrades.find(g => g.slug === slug)
          ?? this.gradeStore.allGrades.find(g => g.slug === slug)
          ?? null;
    },

    gradeName() { return this.grade?.name ?? this.gradeSlug ?? ''; },

    breadcrumbs() {
      return [
        { name: 'الرئيسية', path: '/' },
        { name: this.gradeName, path: `/grades/${this.gradeSlug}/students` },
        { name: 'باركود الطلاب', path: this.$route.fullPath },
      ];
    },
  },

  methods: {
    async fetchStudents() {
      this.loading = true;
      const formData = new FormData();
      formData.append('status', 1);
      formData.append('order_by_name', 1);
      if (this.grade?.id) formData.append('academic_year_id', this.grade.id);

      axios.defaults.headers.common['per_page'] = 100000;
      const res = await axios.post('/all_reservations', formData).catch(() => null);
      const raw = res?.data?.data?.data ?? res?.data?.students ?? [];
      this.students = raw.map(s => ({ user_id: s.user_id ?? s.id, name: s.name }));
      this.loading = false;
    },

    downloadBarcode(student) {
      const bc = this.$refs[`bc_${student.user_id}`];
      if (bc) bc.downloadPng(`barcode-STU-${student.user_id}.png`);
    },
  },

  async mounted() {
    if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
    if (!this.gradeStore.allGrades.length)    await this.gradeStore.fetchAllGrades();
    await this.fetchStudents();
  },
};
</script>
